"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgInbox = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M28.7 15a3 3 0 012.744 1.784l3.47 7.81.008.019a.993.993 0 01.033.088l-.041-.107a1 1 0 01.08.29L35 25v5a3 3 0 01-3 3H16a3 3 0 01-3-3v-5c0-.044.003-.087.008-.13L13 25a1 1 0 01.078-.387l.008-.019 3.47-7.81A3 3 0 0119.3 15h9.4zM15 30a1 1 0 001 1h16a1 1 0 001-1v-4h-4.465l-1.703 2.555A1 1 0 0126 29h-4a1 1 0 01-.832-.445L19.465 26H15v4zm13.7-13h-9.4a1 1 0 00-.916.595L15.538 24H20a1 1 0 01.832.445L22.535 27h2.93l1.703-2.555A1 1 0 0128 24h4.461l-2.845-6.405A1 1 0 0028.7 17z",
    id: "inbox_svg__a"
  }));
};

var _default = SvgInbox;
exports.default = _default;